<style scoped>
.v-application .subtitle-1 {
  font-size: 14px !important;
  font-weight: normal;
  letter-spacing: 0.009375em !important;
  line-height: 1.75rem;
  font-family: "Prompt", sans-serif !important;
}
</style>

<template>
  <span style="display: inline-block">
    <v-select
      v-model="cus_status"
      :background-color="status_color"
      :items="status_item"
      dense
      class="mt-2 mb-n5"
      style="width: 130px; border-radius: 3px"
      @change="changeStatus()"
    ></v-select>
  </span>
</template>

<script>
export default {
  name: "DocStatus",
  props: {
    Page: String,
    TableData: Object,
  },
  data: () => ({
    cus_status: "",
    status_color: "#fff",
    apiUrl: "",
    findObj: {},
    status_item: [],
  }),
  watch: {
    TableData: {
      immediate: true,
      deep: true,
      handler(val, oldVal) {
        this.cus_status = val.DOC_STATUS
        let status = val.DOC_STATUS
        this.changeBgColor(status)
      }
    }

  },
  created() {
    if (this.Page == "Quotation") {
      this.apiUrl = "/update-status-quotation"
      this.status_item = ['อนุมัติ', 'ยกเลิก']


    } else if (this.Page == "Bill") {
      this.apiUrl = "/update-status-bill"
      this.status_item = ['เปิดบิลแล้ว', 'วางบิลแล้ว', 'ยกเลิก']

      // } else if (this.Page == "Contract") {
      //   this.apiUrl = "/update-status-contract"
      //   this.findObj = {
      //     CONTRACT_ID: this.TableData.CONTRACT_ID,
      //     STATUS: this.TableData.DOC_STATUS
      //   }
    } else if (this.Page == "Invoice") {
      this.apiUrl = "/update-status-invoice"
      this.status_item = ['รอเก็บเงิน', 'เก็บเงินแล้ว', 'ยกเลิก']

    }
  },
  methods: {
    changeStatus() {
      let status = this.cus_status
      this.changeBgColor(status)
      this.check_status()
      if (status != "เก็บเงินแล้ว") {
        this.$token_api
          .post(this.apiUrl, this.findObj)
          .then((response) => {
            // console.log(response)
            if (this.Page == "Quotation") {
              this.$parent.$parent.$parent.$parent.list_quotation()
            } else if (this.Page == "Bill") {
              this.$parent.$parent.$parent.$parent.list_bill()
            } else if (this.Page == "Invoice") {
              this.$parent.$parent.$parent.$parent.list_invoices()
            }
          })
          .catch((err) => {
            console.log(err)
          });
      } else {
        this.$swal({
          title: "ยืนยันการชำระเงิน",
          text: `กรุณากดปุ่ม "ยีนยัน" เพื่อยืนยันการชำระเงิน`,
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "ยืนยัน",
          cancelButtonText: "ยกเลิก",
        }).then((result) => {
          if (result.value) {
            this.$token_api.post("/confirm-paid", {
              INVOICE_ID: this.TableData.INVOICE_ID,
              TRANSACTION_ID: this.TableData.TRANSACTION_ID,
              NEWCUSTOMER_ID: this.TableData.NEWCUSTOMER_ID,
              CUS_STATUS: this.TableData.CUS_STATUS
            })
              .then((response) => {
                this.$swal("ยืนยันการชำระเงินสำเร็จ", "สำเร็จ", "success");

              })
              .catch((err) => {
               
                this.$swal("เกิดข้อผิดพลาด", "ลองใหม่อีกครั้ง", "error");
              });
          } else {
            this.status_item = ['รอเก็บเงิน', 'เก็บเงินแล้ว', 'ยกเลิก']
          }
        });
      }

    },
    check_status() {
      if (this.Page == "Quotation") {
        this.findObj = {
          QUOTATION_ID: this.TableData.qt_id,
          DOC_STATUS: this.cus_status
        }
      } else if (this.Page == "Bill") {
        this.findObj = {
          BILL_ID: this.TableData.BILL_ID,
          DOC_STATUS: this.cus_status
        }
      } else if (this.Page == "Invoice") {
        this.findObj = {
          INVOICE_ID: this.TableData.INVOICE_ID,
          DOC_STATUS: this.cus_status
        }
      }
    },
    changeBgColor(status) {
      if (status == 'อนุมัติ') {
        this.status_color = '#BBDEFB'
      } else if (status == 'วางบิลแล้ว') {
        this.status_color = '#FFF9C4'
      } else if (status == 'เปิดบิลแล้ว') {
        this.status_color = '#BBDEFB'
      } else if (status == 'เก็บเงินแล้ว') {
        this.status_color = '#C8E6C9'
      } else if (status == 'รอเก็บเงิน') {
        this.status_color = '#FFF9C4'
      } else if (status == 'ยกเลิก') {
        this.status_color = '#ECEFF1'
      } else {
        this.status_color = '#fff'
      }
    }
  },
};
</script>

